import type {Mailbox} from "./types.ts";

interface ReactNativeWebView {
    postMessage: (message: string) => void;
}

/**
 * A mailbox for sending messages to the mobile app.
 */
export class MobileAppMailbox implements Mailbox {
    /**
     * Get the `window.ReactNativeWebView` object if it is present.
     *
     * @returns The `window.ReactNativeWebView` object if it is present; `undefined`
     * otherwise.
     */
    private _getRNWebView(): ReactNativeWebView | void {
        if ("ReactNativeWebView" in window) {
            return window.ReactNativeWebView as ReactNativeWebView;
        }
    }

    /**
     * Send a message to this mailbox.
     *
     * @param message The message to send.
     */
    send(message: string): void {
        const rnWebView = this._getRNWebView();
        rnWebView?.postMessage(message);
    }

    /**
     * Is this mailbox available?
     *
     * `true` if this mailbox can be used to send messages; otherwise, `false`.
     */
    get canSend(): boolean {
        return this._getRNWebView() != null;
    }
}
